export default __webpack_public_path__ + "static/5_28-18eb836ed57935fe697d30ef54d52735.png";